import React, { Component } from "react"
import {
  FormBuilder,
  FieldGroup,
  FieldControl,
  Validators,
} from "react-reactive-form"
import "./SignIn.scss"
import { selectIcon, SVG } from "../../components/UI/selector"
import { TextInput1, TextInput } from "../../components/UI/FormInput/FormInput"
import { pattern } from "../../services/subscriberService"
import { FormGroups } from "../../components/ReusableComponents/FormGroups/FormGroups"
import { ErrorUI } from "../../components/UI/Modals/Modals"
import { login, Login } from "../../services/CallApi"
import { UniqueID } from "../../services/CommonFunction"
import axios from "../../axios"
import ApiURL from "../../services/ApiURL"
import LoginSignUp from "../../hoc/LoginSignUp/LoginSignUp"
import { profileActions } from "../../store"
import { useDispatch } from "react-redux"
import SocialLogin from "../../components/SocialLogin/SocialLogin"

const SignIn = ({ SignupForm, handleSubmit, navigate }) => {
  return (
    <div className="formDetailContainer">
      <FieldGroup
        control={SignupForm}
        render={({ get, invalid }) => (
          <form onSubmit={handleSubmit}>
            <FormGroups>
              <FieldControl
                name="email"
                render={TextInput}
                meta={{
                  label: "Email address",
                  showLabel: false,
                  type: "email",
                  placeholder: "Email address",
                  placeHolderIcon: "emailInput",
                  valid: true,
                  showError: true,
                }}
              />
            </FormGroups>
            <FormGroups>
              <FieldControl
                name="password"
                render={TextInput}
                meta={{
                  label: "Password",
                  showLabel: false,
                  type: "password",
                  placeholder: "Password",
                  placeHolderIcon: "passwordInput",
                  minLength: "10",
                  maxLength: "50",
                  valid: true,
                  showError: true,
                }}
              />
            </FormGroups>
            <div className="textDiv">
              <p
                className="brightText forgotPassword"
                onClick={() => navigate("ForgotPassword")}
              >
                Forgot your password?
              </p>
            </div>
            <div className="submitDiv">
              <button
                className={`${invalid ? "disabled" : "enabled"}`}
                type="submit"
              >
                <p>Login</p>
              </button>
              <div className="signUpDiv">
                <p className="brightText">Don’t have an account?</p>
                <p className="brightText">
                  <span onClick={() => navigate("SignUp")}>Sign up</span>{" "}
                  instead
                </p>
              </div>
            </div>
            <hr />
          </form>
        )}
      />
      <SocialLogin />
    </div>
  )
}

const headerDetail = {
  heading: "Welcome Back",
  subHeading1: "Join the best digital fitness",
  subHeading2: "experience now!",
  subHeading3: null,
  isLogoRequired: true,
  status: "login",
}

const SignInComponent = LoginSignUp(SignIn, headerDetail)
export default SignInComponent
